import axios from '../../utils/axios';
import CRUD from './crud'

const coachTicketDiscounts = new CRUD('coach-ticket-discounts', 'superior-judge')

export default Object.assign(
    coachTicketDiscounts,
    {
        reducers: {
            ...coachTicketDiscounts.reducers
        },

    }
)
